import invariant from 'invariant';
import { call, put, select } from 'typed-redux-saga/macro';

import { withErrorHandling } from 'Lib/sagaHelpers';
import { getServiceFn } from 'Services';
import { TINDER_U_SERVICE } from 'Services/constants';

import { showNotification } from 'Store/notifications/actions';
import { getTinderUSchool } from 'Store/tinderU/selectors';
import { getDeepLinkOtp } from 'Store/user/selectors';

import { trackEvent } from 'Store/sparks/actions';
import { TINDER_U_VERIFIED } from 'Store/sparks/tinderU/events';

import { ICON_TINDER_U } from 'Containers/Notification/icons.types';
import {
  NOTIFICATION_THEME_ERROR,
  NOTIFICATION_THEME_SUCCESS,
} from 'Components/InAppNotification/constants';

import { verifyTinderUStatusError, verifyTinderUStatusSuccess } from './actions';

export const verifyTinderUStatusSaga = withErrorHandling(
  function* verifyTinderU() {
    const token = yield* select(getDeepLinkOtp);
    invariant(token, 'No verification token supplied');

    yield* call(yield* call(getServiceFn, TINDER_U_SERVICE, 'verifyStatus' as const), token);
    yield* put(verifyTinderUStatusSuccess());

    const school = yield* select(getTinderUSchool);
    yield* put(
      trackEvent(TINDER_U_VERIFIED, {
        schoolId: school?.school_id,
        instantVerify: false, // TODO, integrate instant verify and change value here
      })
    );

    // Show success notification
    yield* put(
      showNotification({
        theme: NOTIFICATION_THEME_SUCCESS,
        title: [{ id: 'TinderU.notificationTitle' }],
        body: [{ id: 'TinderU.notificationBody' }],
        icon: ICON_TINDER_U,
      })
    );
  },
  {
    name: 'verifyTinderUStatusSaga',
    *errorHandler() {
      yield* put(verifyTinderUStatusError());
      yield* put(
        showNotification({
          theme: NOTIFICATION_THEME_ERROR,
          title: [{ id: 'somethingWentWrong' }],
          body: [{ id: 'EmailCollection.verifyErrorNotificationContent' }],
        })
      );
    },
  }
);
